import { MenusInput, MenusOutput } from "@/interfaces/menus";
import { BaseService } from "./BaseService";

export class MenusService extends BaseService<MenusInput, MenusOutput> {
  constructor() {
    super();
    this.path = "menus";
  }
}
